import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import AdoptionMiddleware from '../../modules/adoption/middleware'
import UnitMiddleware from '../../modules/unit/middleware'
import SelectUnits from './../../components/Select/SelectUnits'

const mapStateToProps = ({ units, auth }) => ({
  unit: units.currentItem.item,
  unitCurrent: auth.authUser.units[0],
  authUser: auth.authUser,
  role: auth.userRole.role
})

const mapDispatchToProps = (dispatch) => (
  bindActionCreators({
    changeUnit: (unit) => UnitMiddleware.changeUnitSelect(unit),
    fetchAllAdoption: () => AdoptionMiddleware.fetchAllAdoption()
  }, dispatch)
)

class SelectUnitsContainer extends Component {
  changeUnit = (value) => {
    this.props.changeUnit(value)
    this.props.fetchAllAdoption()
  }
  render () {
    return <SelectUnits
      role={this.props.role}
      authUserUnits={this.props.authUser.units}
      changeUnit={this.changeUnit} />
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(SelectUnitsContainer)



// WEBPACK FOOTER //
// ./src/containers/Select/SelectUnitsContainer.js